import React, { Component } from 'react'
import RadioButton from '../RadioButton'
import PropTypes from 'prop-types'
import { RadioSelectProps, RadioSelectState } from './types'

class RadioSelect extends Component<RadioSelectProps, RadioSelectState> {

  static propTypes = {
    value: PropTypes.string,
    children:
      PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string.isRequired
        })
      ).isRequired
  }

  constructor (props) {

    super(props)

    this.state = {
      value: undefined
    }

  }

  handleChange = e => {

    const newValue = e.target.id.split('-').slice(-1)[0]
    this.setState({ value: newValue })
    if (this.props.onChange) {

      this.props.onChange(this.props.id, newValue)

    }

  }

  static getDerivedStateFromProps (props, state) {

    if (typeof state.value === 'undefined') {

      return {
        value: props.value
      }

    }
    return null

  }

  render () {

    return (
      <div ref={this.props.innerRef} data-bdd={this.props.dataBdd || 'radio-select'} >
        { this.props.children && this.props.children.map((child, i) => {

          return <RadioButton
            dataBdd={'radio-select-option-' + i}
            name={this.props.id}
            id={ `${this.props.id}-${child.value}`}
            checked = {this.state.value === child.value}
            label={child.label}
            value={child.value}
            onChange={this.handleChange}
            disabled={this.props.disabled}
            key={i}/>

        })
        }
      </div>
    )

  }

}

export default RadioSelect
